var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9866 5.9851L12.6016 3.6001V5.4001H4.50156C4.00656 5.4001 3.60156 5.8051 3.60156 6.3001C3.60156 6.7951 4.00656 7.2001 4.50156 7.2001H12.6016V9.0001L14.9866 6.6151C15.1576 6.4441 15.1576 6.1561 14.9866 5.9851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5009 10.8H5.40086V9L3.01586 11.385C2.83586 11.565 2.83586 11.844 3.01586 12.024L5.40086 14.4V12.6H13.5009C13.9959 12.6 14.4009 12.195 14.4009 11.7C14.4009 11.205 13.9959 10.8 13.5009 10.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.fd27f41e4bf742b2060475995bb9e9e4.svg";
export { ForwardRef as ReactComponent };